import StepSomeInformation from './StepSomeInformation';

export default StepSomeInformation;
